import { render, staticRenderFns } from "./primaryContent.vue?vue&type=template&id=e809767a&scoped=true"
import script from "./primaryContent.vue?vue&type=script&lang=js"
export * from "./primaryContent.vue?vue&type=script&lang=js"
import style0 from "./primaryContent.vue?vue&type=style&index=0&id=e809767a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e809767a",
  null
  
)

export default component.exports